import { FC, memo } from 'react';
import isBoolean from 'lodash/isBoolean';
import last from 'lodash/last';
import { DefaultOptionType, SingleValueType } from 'rc-cascader/lib/Cascader';
import Button from 'antd/lib/button/button';
import Cascader from 'antd/lib/cascader';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Input from 'antd/lib/input/Input';
import TextArea from 'antd/lib/input/TextArea';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import { categoriesSelector } from 'store/selectors/categoriesSelectors';
import { selectAccountSettingsMeta, selectStoreSettings } from 'store/selectors/settingsSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { formRules, questionMarks, textareaWithCounterProps } from 'utils/constants/constants';
import { EStoreFields } from 'types/settings/enums';

interface IMyStoreGeneralProps {
  setSelectedCategory: (category: DefaultOptionType | any) => void;
}

const MyStoreGeneral: FC<IMyStoreGeneralProps> = ({ setSelectedCategory }) => {
  const { isStoreConnected } = useTypedSelector(selectAccountSettingsMeta);
  const { isConnectingStore } = useTypedSelector(selectStoreSettings);
  const { isLoading, results } = useTypedSelector(categoriesSelector);

  const handleChangeCategory = (_: SingleValueType, selectedOptions: DefaultOptionType[]) => {
    const lastCategory = last(selectedOptions);

    setSelectedCategory({ category: lastCategory?.value, categoryName: lastCategory?.label });
  };

  const handleAddStore = () => window.location.assign(process.env.REACT_APP_SHOPIFY_DOMAIN!);

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h4 className="mb-0">General</h4>
        {(isBoolean(isStoreConnected) && !isStoreConnected) && (
          <div>
            <QuestionMark>{questionMarks.store.connect}</QuestionMark>
            <Button loading={isConnectingStore} className="ml-2" onClick={handleAddStore}>
              Connect Store
            </Button>
          </div>)}
      </div>
      <Row gutter={20}>
        <Col span={12}>
          <Item
            name="name"
            validateFirst
            label="Store Name"
            rules={[formRules.required, formRules.min3Char, formRules.max30Char, formRules.latinNumberSpecs]}
          >
            <Input size="large" placeholder="Enter Store Name" />
          </Item>
          <Item
            name="categoryName"
            label="Default Category"
            validateFirst
            rules={[formRules.required]}
            tooltip={questionMarks.store.category}
          >
            <Cascader
              size="large"
              loading={isLoading}
              displayRender={last}
              options={results}
              placeholder="Select Category"
              onChange={handleChangeCategory}
            />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            label="Store Description"
            validateFirst
            name={EStoreFields.Description}
            rules={[formRules.required, formRules.min3Char, formRules.latinNumberSpecsEnter]}
            tooltip={questionMarks.store.description}
          >
            <TextArea
              placeholder="Enter Store Description"
              maxLength={300}
              autoSize={{ minRows: 5, maxRows: 5 }}
              {...textareaWithCounterProps}
            />
          </Item>
        </Col>
      </Row>
    </>
  );
};

export default memo(MyStoreGeneral);
